export default __webpack_public_path__ + "static/media/filter_icon.7e651cf5.svg";